import { Copy, ExternalLink, QrCode } from "lucide-react";
import { toast } from "sonner";
import { useI18n } from "../../i18n";
import { useApi } from "./hooks";

// The customer's own SoftOne RF payment code: copy it or open the PayHub (IRIS) page from anywhere
export const RfCard = ({ compact = false }) => {
  const { t } = useI18n();
  const s = useApi("paySummary", "/payments/summary", undefined, { staleTime: 0 });
  const rf = s.data?.rf_code;
  if (!s.data?.enabled || !rf) return null;
  const copy = () => navigator.clipboard?.writeText(rf).then(() => toast.success(t("x.pay.copied")));
  return (
    <section className={`rounded-2xl bg-white shadow-sm ${compact ? "p-3" : "p-4"}`} data-testid="rf-card">
      <div className="flex items-center gap-3">
        <QrCode className="h-6 w-6 shrink-0 text-navy" />
        <div className="min-w-0 flex-1">
          <p className="text-xs text-slate-500">{t("x.pay.rfCardTitle")}</p>
          <p className="break-all font-semibold tabular-nums text-navy" data-testid="rf-card-code">{rf}</p>
        </div>
        <button type="button" onClick={copy} aria-label={t("x.pay.copy")} className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-canvas text-navy" data-testid="rf-card-copy"><Copy className="h-4 w-4" /></button>
      </div>
      {!compact && <p className="mt-2 text-xs text-slate-500">{t("x.pay.rfCardSub")}</p>}
      {s.data.payhub_url && <a href={s.data.payhub_url} target="_blank" rel="noopener noreferrer" className="mt-3 inline-flex h-10 w-full items-center justify-center gap-1.5 rounded-full bg-navy px-4 text-sm font-semibold text-white sm:w-auto" data-testid="rf-card-payhub"><ExternalLink className="h-4 w-4" />{t("x.pay.payWithIris")}</a>}
    </section>
  );
};
